export default __webpack_public_path__ + "static/media/silver-medal.d290a9f5.svg";